var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTexture(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.19,
    height: 25.19,
    viewBox: "0 0 25.19 25.19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4.9 -4.85)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.05 5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.05,5V29.89H29.94V5Zm24.2,12.119H26.914L17.938,8.145V5.692h11.31Zm-12,0H9.056l8.19-8.19Zm0,.692v8.179L9.067,17.811Zm.692,0H25.92L17.938,25.8Zm0-.692v-8l8,8h-8ZM17.246,5.692V7.951l-9.17,9.167H5.742V5.692ZM5.742,17.811H8.09l9.156,9.159V29.2H5.742ZM17.938,29.2V26.773L26.9,17.811h2.348V29.2Z",
    transform: "translate(-5.05 -5)",
    fill: "#0080ff",
    stroke: "#0080ff",
    strokeWidth: 0.3
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTexture);
export default __webpack_public_path__ + "static/media/texture.92e77fe6.svg";
export { ForwardRef as ReactComponent };